import useLandingStore from '../Store/Landing';
import * as Sentry from '@sentry/react';

export const fetchApi = async (
  route: string,
  payload?: object,
  method = 'POST',
  headers?: object
): Promise<{
  ok: boolean;
  data: any;
}> => {
  const options = {
    method,
    headers: {
      'Content-Type': 'Application/json',
      accept: '*/*',
      ...headers
    }
  };
  const token = await getToken();
  if (token) {
    options.headers['Authorization'] = token;
  }
  if (payload) {
    options['body'] = JSON.stringify(payload);
  }
  try {
    const res = await fetch(generateUrl(route), options);
    if (res.status === 200) {
      try {
        const response = await res.json();
        return {
          ok: true,
          // eslint-disable-next-line
          data: response.hasOwnProperty('data') ? response.data : response
        };
      } catch (e) {
        Sentry.captureException(
          new Error(
            'route:' + route + '\n payload:' + payload + '\n json failed: ' + e
          )
        );
        return {
          ok: false,
          data: e
        };
      }
    } else if (res.status === 401) {
      (await renewAccessToken()) &&
        (await fetchApi(route, payload, method, headers));
    } else if (res.status === 500) {
      Sentry.captureException(
        new Error(
          'internal server error. route:' + route + '\n payload:' + payload
        )
      );
      // return asyncApiAwesomeAlert('خطا', 'با عرض پوزش مشکلی در سرور وجود دارد')
      return {
        ok: false,
        data: 'error'
      };
    } else if (res.status === 429) {
      Sentry.captureException(
        new Error(
          'route:' +
            route +
            '\n payload:' +
            payload +
            '\n error status:' +
            res.status
        )
      );
      // return asyncApiAwesomeAlert('خطا', 'داداش نمودی برو بعدا بیا')
      return {
        ok: false,
        data: 'Too Many Requests'
      };
    } else if (res.status === 400) {
      Sentry.captureException(
        new Error(
          'route:' +
            route +
            '\n payload:' +
            payload +
            '\n error status:' +
            res.status
        )
      );
      useLandingStore.getState().setIsThereToken(false);
    } else {
      Sentry.captureException(
        new Error(
          'route:' +
            route +
            '\n payload:' +
            payload +
            '\n error status:' +
            res.status
        )
      );
      // return asyncApiAwesomeAlert('خطا', 'با عرض پوزش مشکلی در سرور وجود دارد')
      return {
        ok: false,
        data: res
      };
    }
  } catch (e) {
    Sentry.captureException(
      new Error(
        'fetch failed. ' +
          '\n route:' +
          route +
          '\n payload:' +
          payload +
          '\n error:' +
          e
      )
    );
    // return asyncApiAwesomeAlert('خطا', 'با عرض پوزش مشکلی در سرور وجود دارد')
    return {
      ok: false,
      data: e
    };
  }
};

const getToken = async () => {
  const access_token = localStorage.getItem('access_token');
  if (access_token) {
    return 'Bearer ' + access_token;
  }
  return null;
};

const generateUrl = (route: string): string => {
  return process.env.REACT_APP_BASE_URL + route;
};

const renewAccessToken = async (): Promise<boolean> => {
  const refresh_token = localStorage.getItem('refresh_token');
  if (refresh_token) {
    const res = await fetchApi('/Account/RefreshToken', {
      RefreshToken: refresh_token
    });
    if (!res.ok) {
      //TODO LOGOUT
      localStorage.setItem('access_token', '');
      localStorage.setItem('refresh_token', '');
      return false;
    } else {
      localStorage.setItem('access_token', res.data.access_token);
      localStorage.setItem('refresh_token', res.data.refresh_token);
      return true;
    }
  } else {
    //TODO LOGOUT
    localStorage.setItem('access_token', '');
    return false;
  }
};

export default fetchApi;
